import React from 'react'

import { Button, Form, Modal, Segment } from '@waylay/react-components'
import { css } from '@emotion/react'

interface INewModal {
  title: string
  dismissText?: string
  submitText: string
  isSubmitting?: boolean
  onDismiss: () => void
  onSubmit: () => void
  children: React.ReactNode
  onAfterOpen?: Function
}

const NewModal = ({
  title,
  dismissText = 'Cancel',
  submitText,
  isSubmitting = false,
  onDismiss,
  onSubmit,
  onAfterOpen,
  children,
}: INewModal) => {
  return (
    <Modal
      isOpen
      onRequestClose={onDismiss}
      onAfterOpen={() => onAfterOpen?.(true)}
    >
      <Segment.Group>
        <Segment.Header data-testid="dialog-title">{title}</Segment.Header>
        <Form
          as={Segment.Group}
          css={css`
            width: 320px;
          `}
          onSubmit={onSubmit}
        >
          <Segment>{children}</Segment>
          <Modal.Actions>
            <Button
              outline
              kind="secondary"
              onClick={onDismiss}
              data-testid="cancel-button"
            >
              {dismissText}
            </Button>
            <Button
              data-testid="submit-button"
              loading={isSubmitting}
              disabled={isSubmitting}
              type="submit"
            >
              {submitText}
            </Button>
          </Modal.Actions>
        </Form>
      </Segment.Group>
    </Modal>
  )
}

export default NewModal
